exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.error {\r\n    color: red;\r\n    margin-bottom: 20px;\r\n    display: inline-block;\r\n}\r\n.btn-success{\r\n    font-weight: bold;\r\n\r\n}\r\n.spacecomponent{\r\n    margin-top: 2em;\r\n}\r\n\r\n.input-group{\r\n    width: 300px;\r\n}\r\n\r\n.button-submit-forgot{\r\n    margin-left: 11em;\r\n}\r\n\r\n.container-form form {\r\n    border: 0px solid #ffffff;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/forgotten-password/forgotten-password.component.css
// module id = 1012
// module chunks = 1